/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-28 14:55:08
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { Card, Layout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Field } from 'redux-form';
import { FILTER_MOBILE_LAYOUTS } from 'src/constants/filter-layout';
import { RenderRadioButtonItem } from 'src/components/views/common/forms/render-radio-button-item';

type Props = {
  filterTreeMobileStyle: string,
  shopifyIntegrationEnabled: boolean
};

type ComposedProps = Props & WithI18nProps;

type State = {
  currentPlay: number
};
class MobileLayout extends Component<ComposedProps, State> {
  state = {
    currentPlay: 0
  };

  componentDidMount() {
    const { filterTreeMobileStyle } = this.props;
    const index = _.findIndex(FILTER_MOBILE_LAYOUTS, item => item.id === filterTreeMobileStyle);
    if (index !== -1) {
      this.setState({ currentPlay: index });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { filterTreeMobileStyle } = this.props;
    const { filterTreeMobileStyle: nextFilterTreeMobileStyle } = nextProps;

    if (nextFilterTreeMobileStyle !== filterTreeMobileStyle) {
      const index = _.findIndex(
        FILTER_MOBILE_LAYOUTS,
        item => item.id === nextFilterTreeMobileStyle
      );
      if (index !== -1) {
        this.setState({ currentPlay: index });
      }
    }
  }

  render() {
    const { i18n, shopifyIntegrationEnabled } = this.props;
    const { currentPlay } = this.state;

    return (
      <div className="BC_FilterLayout-Mobile">
        <Layout>
          {FILTER_MOBILE_LAYOUTS.map((item, index) => {
            return (
              <Layout.Section oneThird key={index}>
                <Card sectioned>
                  <div className="box">
                    <div className="layout-image">
                      <img
                        onMouseEnter={() => this.handleMouseEnter(index)}
                        onMouseLeave={this.handleMouseLeave}
                        src={currentPlay === index ? item.imageGifSrc : item.imageSrc}
                        alt={i18n.translate(item.label)}
                      />
                    </div>
                    <div className="layout-style">
                      <Field
                        name="filterTreeMobileStyle"
                        id={item.id}
                        component={RenderRadioButtonItem}
                        label={i18n.translate(item.label)}
                      />
                    </div>
                  </div>
                </Card>
              </Layout.Section>
            );
          })}
          <Layout.Section oneThird>
            <div />
          </Layout.Section>
          {shopifyIntegrationEnabled && (
            <>
              <Layout.Section oneThird>
                <div />
              </Layout.Section>
              <Layout.Section oneThird>
                <div />
              </Layout.Section>
            </>
          )}
        </Layout>
      </div>
    );
  }

  handleMouseEnter = index => {
    const { currentPlay } = this.state;
    if (currentPlay !== index) {
      this.setState({ currentPlay: index });
    }
  };

  handleMouseLeave = () => {
    const { currentPlay } = this.state;
    const { filterTreeMobileStyle } = this.props;
    const index = _.findIndex(FILTER_MOBILE_LAYOUTS, item => item.id === filterTreeMobileStyle);
    if (index !== -1 && currentPlay !== index) {
      this.setState({ currentPlay: index });
    }
  };
}

export default withI18n()(MobileLayout);
